import { Input, Select } from "antd"
import React, { useRef } from "react"
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"
import { InputSearchStyle } from "../../../Setting/common/styled"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"

const FilterRequest = ({ filter, setFilter,setKeyword }) => {
  const inputSearchRef = useRef()
  const onSearch = () => {
    const keyword =  inputSearchRef.current || "";
      setKeyword(keyword); 
  };
  const onClearSearch = () => {
    inputSearchRef.current = ""; 
    setKeyword(""); 
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
        minWidth: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          maxWidth: "1000px",
        }}
      >
        {/* <div style={{ width: 150 }}>
            <Input
              placeholder="Số lô nhập"
              onChange={e =>
                setFilter(prev => ({ ...prev, batch_number: e.target.value }))
              }
            ></Input>
          </div> */}
        <SelectProvider
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, supplier_id: val }))}
        />
        <SelectCustomer
          style={{ width: 150 }}
          type={"ADMIN"}
          placeholder="Người đề xuất"
          onChange={val =>
            setFilter(prev => ({ ...prev, created_by: val }))
          }
        />

        {/* <CustomRangePicker style={{ width: 250 }} format="DD/MM/YYYY" /> */}
      </div>
      <div>
        <InputSearchStyle>
          <Input
          allowClear
            className="custom-input"
            maxLength={50}
            placeholder="Tìm kiếm theo số lô nhập"
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            onPressEnter={onSearch}
            onClear={onClearSearch}
            size="small"
          />
          <div className="custom-icon-search">
            <SvgIcon name="searchStatistic" onClick={onSearch}/>
          </div>
        </InputSearchStyle>
      </div>
    </div>
  )
}
export default FilterRequest
